module.exports = __webpack_public_path__ + "static/media/no_photo.c83e1bd0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no_photo.gif
// module id = 1295
// module chunks = 0